<template>
  <div>
    <div class="dropbox"  v-if="isInitial || isSaving">
      <input type="file" id="file" multiple :name="uploadFieldName" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files)" class="input-file">
      <div class="center" v-if="isInitial">
        <i class="icon-cloud-upload"></i>
        <p>Arraste seu arquivo aqui</p>
        <p>ou</p>
        <p>
          <button class="btn btn--success">Buscar no computador</button>
        </p>
      </div>
      <p class="center" v-if="isSaving">
        Salvando...
      </p>
    </div>

    <div v-if="isSuccess">
      <i class="icon-file-check2"></i>
      <span>{{ fileName }}</span>
      <i class="icon-cross" @click="reset()"></i>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import notifier from '@/notifier'

  export default {
    data: () => ({
      uploadedFiles: [],
      currentStatus: null,
      uploadFieldName: 'file',
      statusInitial: 0,
      statusSaving: 1,
      statusSuccess: 2,
      fileName: ''
    }),
    props: {
      validateFunction: {
        type: Function,
        required: true
      },
      data: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.reset()
    },
    methods: {
      reset () {
        this.uploadedFiles = []
        const input = document.getElementById('file')
        if (input) {
          input.value = ''
        }
        this.currentStatus = this.statusInitial
      },
      validateFile (file) {
        if (this.data.fileType.indexOf(file.type) === -1 && this.data.fileType.indexOf(file.name.split('.')[1]) === -1) {
          notifier.error('Extensão do arquivo selecionado inválida', 'Erro')
          return false
        }

        if (file.size > this.data.fileSize) {
          notifier.error(`Tamanho do arquivo não deve ultrapassar os ${this.data.fileSize}MB.`, 'Erro')
          return false
        }

        return true
      },
      save (formData) {
        this.currentStatus = this.statusSaving

        api.uploadFile(formData)
          .then(x => {
            this.$emit('file', x.url)
            this.uploadedFiles = [].concat(x)
            this.currentStatus = this.statusSuccess
          })
          .catch(() => {})
      },
      filesChange (fieldName, fileList) {
        const formData = new FormData()
        this.fileName = fileList[0].name

        if (!fileList.length) {
          notifier.error('Nenhum arquivo selecionado.', 'Erro')
          return
        }

        if (fileList.length > 1) {
          notifier.error('Selecione apenas um arquivo.', 'Erro')
          this.reset()
          return
        }

        Array
          .from(Array(fileList.length).keys())
          .map(x => {
            const reader = new FileReader()
            let headerFile = ''
            reader.onload = () => {
              headerFile = reader.result.split(/[\r\n]+/g)[0]

              if (this.validateFile(fileList[x]) && this.validateFunction(headerFile)) {
                formData.append(fieldName, fileList[x], fileList[x].name)
                this.fileContent = reader.result
                this.save(formData)
              } else {
                this.reset()
              }
            }
            reader.readAsText(fileList[x])
          })
      }
    },
    computed: {
      isInitial () {
        return this.currentStatus === this.statusInitial
      },
      isSaving () {
        return this.currentStatus === this.statusSaving
      },
      isSuccess () {
        return this.currentStatus === this.statusSuccess
      }
    }
  }
</script>

<style lang="sass" scoped>
  .dropbox
    outline: 2px dashed #d2cdcd
    background: #f9fdfd
    color: dimgray
    padding: 10px 10px
    min-height: 200px
    position: relative
    cursor: pointer

    .input-file
      opacity: 0
      width: 100%
      height: 200px
      position: absolute
      cursor: pointer
      z-index: 1

    .center
      font-size: 1.2em
      text-align: center
      padding: 50px 0

    .icon-cloud-upload
      font-size: 20px
      margin-bottom: 10px

  .icon-cross
    font-size: 8px
    cursor: pointer
    margin-top: 3px
    margin-left: 3px
</style>



// WEBPACK FOOTER //
// UploadFile.vue?f184532a